<template>
    <div grey-back full-height class="display_wrapper">
        <dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker>

        <dialog-number-series ref="ref_dialogNumberSeries" :checkTransactionNumber="fn_checkTransactionNumber"></dialog-number-series>
        <dialog-form ref="ref_dialogForm" :closeDialog="fn_closeDialogForm"></dialog-form>
        <dialog-product ref="ref_dialogProduct"></dialog-product>
        <dialog-select-batch ref="ref_dialogSelectBatch" :appendBatches="fn_appendBatches" :pid="Form.productData.productId" :productData="Form.productData" :openDatePicker="fn_openDatePicker" formType="outward" v-if="Form.productData"></dialog-select-batch>
        <dialog-datepicker-batch ref="ref_dialogDatePickerBatch" :selected="selectedDate" :updateDate="fn_updateBatchDate"></dialog-datepicker-batch>
        <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="confirmationAction" okBtnText="Yes" cancelBtnText="No" :displayView="true" :params="confirmationActionParam"></dialog-confirmation>
    </div>
</template>

<script>
const transactionData = require('../../datamodel').data.transactionData;
import dialogDatePicker from '../../../dialogs/dialog_datepicker'
import dialogForm from './dialogs/dialog_form'
import dialogProduct from './dialogs/dialog_product'
import {transactionMixin} from '../../transaction_mixin'

import dialogNumberSeries from '../dialogs/dialog_number_series_manual'
import dialogSelectBatch from '../dialogs/dialog_select_batch'
import dialogDatepickerBatch from '../../../dialogs/dialog_datepicker_batch'
import dialogConfirmation from '../../../dialogs/dialog_confirmation'

import {draftMixin} from '../../../draft_mixin'

    export default{
        props:['settings'],
        mixins: [transactionMixin, draftMixin],
        data(){
            return{

                Form:{
                    "transactionData":JSON.parse(JSON.stringify(transactionData)),
                    "selectedFromGodown":null,
                    "selectedToGodown":null,
                    "productId":null,
                    "productName":null,
                    "qty":null,
                    "summaryArray":[],
                    "transactionProducts":[],
                    "productData":null,
                    "averageRate":null,
                    "selectedProduct":null,
                    "selectedBatchType":null,
                    "batches":[],
                    "isNew":true,
                    "selectedItemIndex":null,
                    "transactionAddOns":[],
                    "addOnsProp":{},
                    "addOnsDataModel": {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":null, "type":null},
                    "numberSeriesData":null
                },
                productData:null,
                summaryArray:null,
                loading:false,
                tagId:null,
                draftStorageId:null,
                dialogStorageId:null,
                backButtonPress: false,
                // unwatch:false,
                disabledBtn:false,
                hasOnlySeries:true,
                hasSeries:false,
                selectedDate:null,
                dateType:null,
                transactionNumberSnackbar:false,
            }
        },
        components:{
            'dialog-datepicker':dialogDatePicker,
            'dialog-form': dialogForm,
            'dialog-select-batch':dialogSelectBatch,
            'dialog-datepicker-batch':dialogDatepickerBatch,
            'dialog-product':dialogProduct,
            'dialog-number-series': dialogNumberSeries,
            'dialog-confirmation':dialogConfirmation,
        },
        watch:{
            'Form': {
                handler: function (){
                    if(!this.unwatch){
                        this.fn_saveDraft(this.draftStorageId, "Stock Transfer");
                    }
                    this.unwatch = false;
                },
                deep: true
            }
        },
        methods:{

            fn_openDatePicker: function (type, date) {
                this.dateType = type;
                this.selectedDate = date ? date : this.$root.fn_getLocalDateFormat();
                if(type=='transactionDate'){
                    this.$refs['ref_dialogDatePicker'].openDialogWeb();
                    this.$refs['ref_dialogDatePicker'].disableBtn = false;
                }
                else{
                    this.$refs['ref_dialogDatePickerBatch'].openDialogWeb();
                    this.$refs['ref_dialogDatePickerBatch'].disableBtn = false;
                }
            },

            fn_addProduct: function(type, index){
                if(!this.Form.selectedFromGodown || !this.Form.selectedFromGodown.itemId){
                    this.$eventHub.$emit('snackbarAlert', {msg:'Select From Godown'});
                    return;
                }

                this.Form.selectedItemIndex = type == 'edit' ? index : null;

                this.Form.selectedProduct = null;
                this.Form.qty = null;
                this.Form.averageRate = null;
                this.Form.productData = null;
                this.Form.summaryArray = [];
                this.$refs['ref_dialogProduct'].openDialogWeb();
            },

            fn_updateBatchDate: function (value) {
                this.$refs['ref_dialogSelectBatch'].fn_updateDate(value, this.dateType);
                this.fn_closeDialog();
            },

            fn_closeDialogForm: function(){
                this.$refs['ref_dialogForm'].closeDialogWeb();
                setTimeout(()=>{
                    this.fn_goBack();
                })
            },

            // fn_openDatePicker: function (type, date) {
            //     let self = this;
            //     this.selectedDate = date;
            //     setTimeout(function () {
            //       self.$refs['ref_dialogDatePicker'].openDialogWeb();
            //     })
            // },

            fn_updateDate: function (value) {
                // this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(value);
                // this.$refs['ref_dialogDatePicker'].closeDialogWeb();
                this.fn_updateTransactionDate(value, this.Form.isNew);
            },

            fn_getSummaryGodownWise: function (itemId) {
                var self = this;
                let filterObj = {};
                filterObj.godownId = this.Form.selectedFromGodown.itemId;
                filterObj.productId = itemId;
                this.getFilterData('ProductSummary', null, filterObj, null,
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.Form.summaryArray = JSON.parse(response);
                        }, 
                        onError: function(error){
                        console.log(error);
                        }
                    }
                );
            },

            // fn_getSummary: function (itemId) {
            //     var self = this;
            //     this.getData('ProductSummary', itemId, 
            //         {
            //             onSuccess: function(response){
            //                 console.log(response);
            //                 self.Form.summaryArray = JSON.parse(response);
            //             }, 
            //             onError: function(error){
            //               console.log(error);
            //             }
            //         }
            //     );
            // },

            fn_getProductData: function (itemId, batches, isEdit) {
                var self = this;
                this.getData('Product', itemId, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.Form.productData = JSON.parse(response);
                            //   self.fn_getSummary(itemId);
                            if(self.Form.productData.groupTypeId==101){
                                self.fn_getBatches(self.Form.productData.productId, batches);
                            }
                            self.fn_getSummaryGodownWise(itemId);

                            if(!isEdit){
                                self.fn_getAverageRate(itemId);
                            }                            
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_getAverageRate: function(itemId){
                let self = this;
                let filterObject = {};
                filterObject.productId = itemId;
                filterObject.GSTRegistrationStatus = this.$root.CurrentBusiness.GSTRegistrationStatus;
                filterObject.endDate = this.Form.transactionData.transactionDate;
                this.getFilterData('GetProductAverageRate', null, filterObject, null,
                    {
                        onSuccess: function(response){
                            console.log(response);
                            if(response){
                                self.Form.averageRate = self.roundUpto2Decimals(Number(response));
                            }
                            else{
                                self.Form.averageRate = 0;
                            }
                        }, 
                        onError: function(error){
                              console.log(error);
                        }
                    }
                );
            },

            fn_getBatches: function(productId, addedBatches){
                let self = this;
                this.getData('GetProductBatchByProductId', productId, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.$set(self.Form, 'batches', JSON.parse(response));

                            if(addedBatches && addedBatches.length){
                                self.$set(self.Form.productData, 'batches', JSON.parse(JSON.stringify(addedBatches)));

                                for(let i=0; i<addedBatches.length; i++){
                                    let bIndex = self.Form.batches.findIndex(bItem=>{return bItem.batchId == addedBatches[i].batchId});
                                    if(bIndex == -1){
                                        self.Form.batches.push(addedBatches[i]);
                                    }
                                }
                            }
                            // if(self.$parent.Form.productData.batches && self.$parent.Form.productData.batches.length){
                            // 	self.$parent.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
                            // }
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },
            fn_openDialogSelectBatch: function(){
                for(let i=0; i<this.Form.batches.length; i++){
                    this.Form.batches[i].selected = false;
                    this.Form.batches[i].productQty = null;
                }

                if(this.Form.productData.batches && this.Form.productData.batches.length){
                    for(let i=0; i<this.Form.batches.length; i++){
                        this.Form.batches[i].productQty = null;
                        this.Form.batches[i].selected = false;
                        for(let j=0; j<this.Form.productData.batches.length; j++){
                            if(this.Form.productData.batches[j].batchId == this.Form.batches[i].batchId){
                                if(this.Form.productData.batches[j].productQty){
                                    this.Form.batches[i].selected = true;
                                    this.Form.batches[i].productQty = this.Form.productData.batches[j].productQty;
                                }
                            }
                        }
                    }
                }
                
                // if(this.Form.productBatches && this.Form.productBatches.length){
                //     for(let i=0; i<this.Form.batches.length; i++){
                //         this.Form.batches[i].productQty = null;
                //         this.Form.batches[i].selected = false;
                //         for(let j=0; j<this.Form.productBatches.length; j++){
                //             if(this.Form.productBatches[j].batchId == this.Form.batches[i].batchId){
                //                 if(this.Form.productBatches[j].productQty){
                //                     this.Form.batches[i].selected = true;
                //                     this.Form.batches[i].productQty = this.Form.productBatches[j].productQty;
                //                 }
                //             }
                //         }
                //     }
                // }
                this.$refs['ref_dialogSelectBatch'].openDialogWeb();
            },

            fn_getData: function (itemId) {
                let self = this;
                this.Form.isNew = false;
                this.getData('GetStockTransfer', itemId, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let data = JSON.parse(response);
                            self.fn_bindData(data);
                        }, 
                        onError: function(error){
                          console.log(error);
                        }
                    }
                );
            },

            fn_bindData: function (data) {
                // this.fn_getTransactionTypeData(data.transactionTypeFormId, null, false);
                this.Form.transactionData.additionalData = data.additionalData;
                this.Form.transactionData.amount = data.amount;
                this.Form.transactionData.businessId = data.businessId;
                this.Form.transactionData.createdBy = data.createdBy;
                this.Form.transactionData.createdDate = data.createdDate;
                this.Form.transactionData.currencyId = data.currencyId;
                this.Form.transactionData.dueDate = data.dueDate;
                this.Form.transactionData.dueType = data.dueType;
                this.Form.transactionData.modifiedBy = data.modifiedBy;
                this.Form.transactionData.modifiedDate = data.modifiedDate;
                this.Form.transactionData.notes = data.notes;
                this.Form.transactionData.partyId = data.partyId;
                this.Form.transactionData.paymentMode = data.paymentMode;
                this.Form.transactionData.prefix = data.prefix;
                this.Form.transactionData.refDate = data.refDate;
                this.Form.transactionData.refNumber = data.refNumber;
                this.Form.transactionData.roundedAmount = data.roundedAmount;
                this.Form.transactionData.salesmanId = data.salesmanId;
                this.Form.transactionData.status = data.status;
                this.Form.transactionData.suffix = data.suffix;
                this.Form.transactionData.transactionDate = data.transactionDate;
                this.Form.transactionData.transactionId = data.transactionId;
                this.Form.transactionData.transactionListId = data.transactionListId;
                this.Form.transactionData.transactionNumber = data.transactionNumber;
                this.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
                // this.Form.transactionProductsTemp = JSON.parse(JSON.stringify(data.transactionProducts));
                // this.Form.transactionProducts = JSON.parse(JSON.stringify(data.transactionProducts));
                this.Form.transactionProducts = [];
                for(let i=0; i<data.transactionProducts.length; i++){
                    let itemIndex  = this.Form.transactionProducts.findIndex(item=>{return item.productId == data.transactionProducts[i].productId})
                    if(itemIndex==-1){
                        data.transactionProducts[i].qty = data.transactionProducts[i].productVariants[0].qty;
                        data.transactionProducts[i].unitId = data.transactionProducts[i].productVariants[0].unitId;
                        data.transactionProducts[i].unitName = data.transactionProducts[i].productVariants[0].unitName;
                        data.transactionProducts[i].productVariantId = data.transactionProducts[i].productVariants[0].productVariantId;
                        data.transactionProducts[i].primaryUnitId = data.transactionProducts[i].productVariants[0].primaryUnitId;
                        data.transactionProducts[i].secondaryUnitId = data.transactionProducts[i].productVariants[0].secondaryUnitId;
                        data.transactionProducts[i].packQuantity = data.transactionProducts[i].productVariants[0].packQuantity;
                        data.transactionProducts[i].secondaryUnitPackQuantity = data.transactionProducts[i].productVariants[0].secondaryUnitPackQuantity;
                        data.transactionProducts[i].averageRate = data.transactionProducts[i].rate;

                        data.transactionProducts[i].batches = [];

                        if(data.transactionProducts[i].transactionProductBatches && data.transactionProducts[i].transactionProductBatches.length){
                            for(let j=0; j<data.transactionProducts[i].transactionProductBatches.length; j++){
                                data.transactionProducts[i].transactionProductBatches[j].productQty = data.transactionProducts[i].transactionProductBatches[j].qty;
                                data.transactionProducts[i].batches.push(data.transactionProducts[i].transactionProductBatches[j]);
                            }
                        }

                        this.Form.transactionProducts.push(data.transactionProducts[i]);
                    }
                }

                
                this.fn_getGodowns();
                this.Form.selectedFromGodown = {itemId:data.fromGodownId, itemName:data.fromGodownName};
                this.Form.selectedToGodown = {itemId:data.toGodownId, itemName:data.toGodownName};

                this.Form.transactionAddOns = [];

                if(data.transactionAddOns && data.transactionAddOns.length){
                    let self = this;
                    data.transactionAddOns.forEach(function (item) {

                        item.mode == 1 ? item.percentage = null : '';

                        let addOnsItem = JSON.parse(JSON.stringify(item));
                        
                        self.Form.transactionAddOns.push(addOnsItem);

                    });

                }

                // this.Form.rate = products[0].variants[0].rate;
                // this.Form.qty = products[0].variants[0].qty;
                // this.type = products[0].variants[0].transactionProductMode ? 'plus' : 'minus';

                // this.Form.selectedBatchType = products[0].selectedBatchType;

                // if(products[0].transactionProductBatches && products[0].transactionProductBatches.length){
                // 	this.Form.productBatches = [];
                // 	for(let i=0; i<products[0].transactionProductBatches.length; i++){
                // 		products[0].transactionProductBatches[i].productQty = products[0].transactionProductBatches[i].qty;
                // 		this.Form.productBatches.push(JSON.parse(JSON.stringify(products[0].transactionProductBatches[i])))
                // 	}
                // }

                // this.fn_getProductData(data.productId, true, products);

                // this.Form.transactionTypeFormId = data.transactionTypeFormId;
                // this.Form.transactionTypeFormName = data.transactionTypeFormName;

                // this.Form.transactionData.numberSeriesId = data.numberSeriesId;
                // this.Form.transactionData.transactionNumberId = data.transactionNumberId;

                // let self = this;
                // this.Form.transactionProductsTemp.forEach(function (item) {
                // 	item.transactionProductMode = item.variants[0].transactionProductMode;
                // 	self.fn_getGroupTotal(item);
                // });

                // setTimeout(function(){
                // 	self.$root.fn_copyFormObject(self.Form, self.formId);
                // },500);
            },

            fn_checkValidations: function(){
                if(this.Form.selectedFromGodown.itemId == this.Form.selectedToGodown.itemId){
                    this.$eventHub.$emit('snackbarAlert', {msg:'Both godowns cannot be same.'});
                    this.saveBtnKey++;
                    this.disableOnSave = false;
                    return;
                }

                if(!this.Form.transactionProducts || (this.Form.transactionProducts && !this.Form.transactionProducts.length)){
                    this.$eventHub.$emit('snackbarAlert', {msg:'Add items'});
                    this.saveBtnKey++;
                    this.disableOnSave = false;
                    return;
                }
                
                this.disabledBtn = true;
                this.fn_checkTransactionNumber(()=>{
                    this.fn_post();
                });
                // this.fn_post();
                // this.showLoading('Please Wait...');
                // this.$validator.validateAll().then((result) => {
             //        if (result) {
             //         this.fn_post();
             //     }
             //     else{
             //         this.disabledBtn = false;
             //         this.hideLoading();
             //     }
             //    });
            },

            fn_saveLocal: function(dataObj){
                var self = this;
                this.postData('PostStockTransfer', dataObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            // self.hideLoading();
                            setTimeout(()=>{
                                self.$eventHub.$emit('UpdateStockTransferList', {}); 
                            },100);

                            //  let adjustmentType = self.type == 'minus' ? 'stock_reduced' : 'stock_added'; 
                            
                            // // posting metrics on save
                            // let postObj = {"eventName":'stock_adjustment_save',"eventData":[{"eventKey":"adjust_type","eventValue":adjustmentType}]}
                              
                            // let saveObj = {};
                            // saveObj.eventKey = "transaction_save";
                            // saveObj.eventValue = adjustmentType;
                            // postObj.eventData.push(saveObj);
                            
                            // self.$root.fn_postMetrics(postObj);

                            // self.fn_goBack();
                            self.fn_previewInvoice(false, "inventory", 'st', null);
                        },
                        onError: function(error){
                            console.log(error);
                            self.saveBtnKey++;
                            self.disableOnSave = false;
                            // self.hideLoading();
                            let response = JSON.parse(error);
                            if(response && response.negativeProducts && response.negativeProducts.length){
                                self.fn_shortListInvalidItems(response.negativeProducts);
                            }
                        }
                    }
                );
            },

            fn_post: function(){

                //only in case of new transaction
                if(!this.Form.transactionData.transactionId){
                    this.Form.transactionData.transactionId = this.guid();
                    // this.Form.transactionData.createdDate = new Date();
                    this.Form.transactionData.createdDate = this.$root.fn_getLocalDateFormat();
                    this.Form.transactionData.transactionListId = this.settings.transactionTypeId;
                }

                // this.Form.transactionData.modifiedDate = new Date();
                this.Form.transactionData.modifiedDate = this.$root.fn_getLocalDateFormat();

                this.Form.transactionData.amount = this.totalAmount;
                this.Form.transactionData.roundedAmount = this.totalAmount;
                this.Form.transactionData.status = 1;
                this.Form.transactionData.transactionTypeFormId = this.Form.transactionTypeFormId;
                this.Form.transactionData.refDate = null;

                this.Form.transactionData.fromGodownId = this.Form.selectedFromGodown.itemId;
                this.Form.transactionData.toGodownId = this.Form.selectedToGodown.itemId;

                let postObj = {};

                postObj = this.Form.transactionData;

                postObj.transactionAddOns = [];
                postObj.masterProductBatches = [];
                postObj.transactionProductBatches = [];
                
                // this.Form.transactionProducts = [];
                let transactionProducts = [];
                // process for from godown
                this.fn_processTransactionProducts('from', transactionProducts, postObj);
                // process for to godown
                this.fn_processTransactionProducts('to', transactionProducts, postObj);

                postObj.transactionProducts = transactionProducts;

                if(this.Form.transactionAddOns.length){

                    this.Form.transactionAddOns.forEach(function (addOnsItem, index) {
                        
                        let addOnsObj = {};

                        if(addOnsItem.value!==null && addOnsItem.value!==''){

                            addOnsObj.transactionAddOnsId = addOnsItem.transactionAddOnsId;
                            addOnsObj.orderNumber = index+1;
                            addOnsObj.addOnsId = addOnsItem.addOnsId;

                            //saving name, nature and mode for display purpose only
                            addOnsObj.addOnsName = addOnsItem.name;
                            addOnsObj.addOnsNature = addOnsItem.nature;
                            addOnsObj.addOnsMode = addOnsItem.mode;

                            addOnsObj.addOnsType = 3;
                            addOnsObj.percentage = null
                            addOnsObj.value = addOnsItem.value;
                            addOnsObj.appliedOn = 0;
                            addOnsObj.adjustInTotal = false;

                            addOnsObj.isDefault = false;

                            addOnsObj.isGst = 0;
                            
                            postObj.transactionAddOns.push(addOnsObj);

                        }

                    })
                }

                postObj.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
                postObj.sortDate = this.$moment(this.Form.transactionData.transactionDate).format('YYYY-MM-DD');

                // if(this.Form.selectedBatchType == 2){
                // 	this.Form.productBatches = this.Form.productBatches.filter(batch=>{
                // 		return batch.field1 || batch.field2 || batch.field3
                // 	})
                // }
                // else{
                // 	this.Form.productBatches = this.Form.productBatches.filter(batch=>{
                // 		return !batch.field1 && !batch.field2 && !batch.field3
                // 	})
                // }

                // if(this.Form.productBatches && this.Form.productBatches.length){
                // 	//adding batches to transaction
                // 	for(let i=0; i<this.Form.productBatches.length; i++){
                // 		let obj = {};
                // 		obj.productId = this.Form.productData.productId;
                // 		obj.transactionProductBatchId = this.guid();
                // 		obj.batchId = this.Form.productBatches[i].batchId;
                // 		obj.transactionProductId = tpObj.transactionProductId;
                // 		obj.qty = this.Form.productBatches[i].productQty;
                // 		obj.orderNumber = i + 1;
                // 		obj.transactionId = this.Form.transactionData.transactionId;
                // 		obj.transactionListId = this.Form.transactionData.transactionListId;
                // 		if(this.type == 'minus'){
                // 			obj.actualQty = -this.Form.productBatches[i].productQty;
                // 		}
                // 		else{
                // 			obj.actualQty = this.Form.productBatches[i].productQty;
                // 		}

                // 		if(this.Form.selectedUnit && this.Form.selectedUnit.itemId && this.Form.selectedUnit.itemId != tpObj.primaryUnitId){
                // 			obj.actualQty = this.roundUpto5Decimals((obj.actualQty * tpObj.packQuantity) / this.Form.productData.productVariants[0].secondaryUnitPackQuantity);
                // 		}
                        
                // 		postObj.transactionProductBatches.push(obj);

                // 		if(this.Form.productBatches[i].isNew){
                // 			delete this.Form.productBatches[i].isNew;
                // 			this.Form.productBatches[i].productId = this.Form.productData.productId;
                // 			this.Form.productBatches[i].orderNumber = this.Form.batches.length + (i + 1);
                // 			postObj.masterProductBatches.push(this.Form.productBatches[i]);
                // 		}
                // 	}
                // }
                
                console.log(this.Form);
                this.fn_saveLocal(postObj);
            },

            fn_processTransactionProducts: function(type, transactionProducts, postObj){
                for(let i=0; i<this.Form.transactionProducts.length; i++){
                    let tpObj = {};
                    tpObj.transactionProductId = this.guid();
                    tpObj.transactionId = this.Form.transactionData.transactionId;
                    tpObj.productId = this.Form.transactionProducts[i].productId;
                    tpObj.productVariantId = this.Form.transactionProducts[i].productVariantId;
                    tpObj.groupId = this.guid();
                    tpObj.mrp = null;
                    tpObj.rate = this.Form.transactionProducts[i].averageRate ? this.Form.transactionProducts[i].averageRate : null;
                    tpObj.additionalData = null;
                    tpObj.unitId = this.Form.transactionProducts[i].unitId;
                    tpObj.primaryUnitId = this.Form.transactionProducts[i].primaryUnitId;
                    if(this.Form.transactionProducts[i].secondaryUnitId){
                        tpObj.secondaryUnitId = this.Form.transactionProducts[i].secondaryUnitId	
                    }

                    if(this.Form.transactionProducts[i].secondaryUnitPackQuantity){
                        tpObj.secondaryUnitPackQuantity = this.Form.transactionProducts[i].secondaryUnitPackQuantity;	
                    }

                    tpObj.qty = this.Form.transactionProducts[i].qty;
                    tpObj.packQuantity = this.Form.transactionProducts[i].packQuantity ? this.Form.transactionProducts[i].packQuantity : 1;
                    tpObj.amount = this.roundUpto2Decimals(tpObj.rate * tpObj.qty);
                    tpObj.netAmount = this.roundUpto2Decimals(tpObj.rate * tpObj.qty);
                    tpObj.taxableValue = this.roundUpto2Decimals(tpObj.rate * tpObj.qty);

                    if(type == 'from'){
                        tpObj.fromGodownId = this.Form.selectedFromGodown.itemId;
                        tpObj.transactionProductMode = 0;
                        tpObj.actualQty = -this.Form.transactionProducts[i].qty;
                    }
                    else{
                        tpObj.toGodownId = this.Form.selectedToGodown.itemId;
                        tpObj.transactionProductMode = 1;
                        tpObj.actualQty = this.Form.transactionProducts[i].qty;
                    }
                    
                    // tpObj.selectedBatchType = this.Form.selectedBatchType;

                    // if(this.Form.selectedUnit && this.Form.selectedUnit.itemId && this.Form.selectedUnit.itemId != tpObj.primaryUnitId){
                    //     tpObj.actualQty = this.roundUpto5Decimals((tpObj.actualQty * tpObj.packQuantity) / this.Form.productData.productVariants[0].secondaryUnitPackQuantity);
                    // }

                    transactionProducts.push(tpObj);

                    if(this.Form.transactionProducts[i].batches && this.Form.transactionProducts[i].batches.length){
                        //adding batches to transaction
                        let item = this.Form.transactionProducts[i];
                        for(let i=0; i<item.batches.length; i++){
                            let obj = {};
                            obj.productId = tpObj.productId;
                            obj.transactionProductBatchId = !this.Form.isNew && item.batches[i].transactionProductBatchId ? item.batches[i].transactionProductBatchId : this.guid();
                            obj.batchId = item.batches[i].batchId;
                            obj.transactionProductId = tpObj.transactionProductId;
                            obj.qty = item.batches[i].productQty;
                            obj.orderNumber = i + 1;
                            obj.transactionId = this.Form.transactionData.transactionId;
                            obj.transactionListId = this.Form.transactionData.transactionListId;

                            // if(tpObj.refTId){
                            // 	obj.refTId = tpObj.refTId;
                            // 	if(item.baseTransactionListId != transactionTypes.order.id){
                            // 		if(item.batches[i].refTpBatchId){
                            // 			obj.refTpBatchId = item.batches[i].refTpBatchId;
                            // 		}
                            // 		else if(item.batches[i].refTransactionProductBatchId){
                            // 			obj.refTpBatchId = item.batches[i].refTransactionProductBatchId;
                            // 		}
                            // 		else{
                            // 			obj.refTpBatchId = item.batches[i].transactionProductBatchId;
                            // 		}
                            // 	}
                            // }

                            obj.actualQty = type == 'from' ? -item.batches[i].productQty : item.batches[i].productQty;

                            // if(item.productVariants[0].selectedUnit && item.productVariants[0].selectedUnit.itemId != item.productVariants[0].primaryUnitId){
                            // 	obj.actualQty = self.roundUpto5Decimals((obj.actualQty * item.productVariants[0].packQuantity) /item.productVariants[0].secondaryUnitPackQuantity);
                            // }

                            postObj.transactionProductBatches.push(obj);

                            if(item.batches[i].isNew){
                                delete item.batches[i].isNew;
                                item.batches[i].productId = tpObj.productId;
                                item.batches[i].orderNumber = this.Form.batches.length + (i + 1);
                                postObj.masterProductBatches.push(item.batches[i]);
                            }
                        }
                    }
                }
            },

            fn_changeBatchQty: function(){
                if(this.Form.productData.batches && this.Form.productData.batches.length){
                    let totalVal = 0;
                    for(let i=0; i<this.Form.productData.batches.length; i++){
                        totalVal += this.Form.productData.batches[i].productQty;
                    }
                    this.Form.qty = Number(totalVal);
                }
            },

            fn_removeBatch: function(batchIndex){
                this.Form.productData.batches.splice(batchIndex, 1);
                let totalQty = 0;
                for(let i=0; i<this.Form.productData.batches.length; i++){
                    totalQty = totalQty + Number(this.Form.productData.batches[i].productQty);
                }
                this.Form.productData.productVariants[0].qty = totalQty ? totalQty : null;
                this.Form.qty = totalQty;
                // this.$forceUpdate();
            },

            fn_appendBatches: function(batches){
                if(batches.length){
                    // for(let i=0; i<batches.length; i++){
                    // 	if(!this.Form.productData.items[0].batches || !this.Form.productData.items[0].batches.length){
                    // 		this.Form.productData.items[0].batches = [];
                    // 	}
                    // 	let bIndex = this.Form.productData.items[0].batches.findIndex(bat=>{return bat.batchId === batches[i].batchId});
                    // 	if(bIndex != -1){
                    // 		this.Form.productData.items[0].batches[bIndex] = JSON.parse(JSON.stringify(batches[i]));
                    // 	}
                    // 	else{
                    // 		this.Form.productData.items[0].batches.push(JSON.parse(JSON.stringify(batches[i])));
                    // 	}
                    // 	this.$forceUpdate();
                    // }
                    this.$set(this.Form.productData, 'batches', JSON.parse(JSON.stringify(batches)));
                    // this.Form.productData.items[0].batches = JSON.parse(JSON.stringify(batches));
                    let totalQty = 0;

                    let bat = null;
                    if(this.Form.selectedBatchType == 2){
                        bat = batches.filter(field=>{
                            return !field.batchNumber && !field.batchMRP && !field.purchaseRate && !field.batchSize && !field.mfgDate && !field.expDate && !field.field4
                        })

                        if(this.Form.productData){
                            if(this.Form.productData.productVariants[0].selectedUnit){
                                this.Form.productData.productVariants[0].selectedUnit = {"itemId":this.Form.productData.productVariants[0].primaryUnitId, "itemName":this.Form.productData.productVariants[0].primaryUnitName}
                            }
                        }
                    }
                    else{
                        bat = batches.filter(field=>{
                            return !field.field1 && !field.field2 && !field.field3
                        })

                        if(batches.length == 1 && batches[0].batchMRP){
                            if(this.$root.TransactionSettings.mrpWiseStock && this.$root.TransactionSettings.mrpAsSalePrice && this.Form.productData.mrp){
                                this.$set(this.Form.productData, 'rate', Number(batches[0].batchMRP));
                            }
                        }
                    }
                    
                    for(let i=0; i<bat.length; i++){
                        totalQty += Number(bat[i].productQty);
                    }
                    // this.Form.productData.items[0].productVariants[0].qty = Number(totalQty);
                    this.$set(this.Form, 'qty', Number(totalQty));
                    this.$set(this.Form.productData.productVariants[0], 'qty', Number(totalQty));
                }
                this.$refs['ref_dialogSelectBatch'].closeDialogWeb();
            },

            fn_fieldVisibilty: function(field, selectedBatchType){
                if(field.status){
                    if(selectedBatchType == 2){
                        if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
                            return true;
                        }
                        else{
                            return false;
                        }
                    }
                    else{
                        if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'opening' || field.id == 'field4'){
                            return true;
                        }
                        else{
                            return false;
                        }
                    }
                }
                else{
                    return false
                }
            },

            fn_showHideBatches: function(field){
                if(this.Form.selectedBatchType == 2 && !field.batchNumber && !field.batchMRP && !field.batchSize && !field.mfgDate && !field.expDate && !field.field4){
                    return true;
                }
                else if(this.Form.selectedBatchType == 1 && !field.field1 && !field.field2 && !field.field3){
                    return true;
                }
                else{
                    return false;
                }
            },

            fn_changeBatchType: function(val){
              if(val==2 && this.Form.productData.batches && this.Form.productData.batches.length){
                if(this.Form.selectedUnit){
                  this.Form.selectedUnit = {"itemId":this.productData.productVariants[0].unitId, "itemName":this.productData.productVariants[0].unitName}
                }
              }
            },

             fn_addOns: function(){
                let filterObject = {};
                filterObject.search = '';
                filterObject.addOnType = 3;

                filterObject.startIndex = 0;
                filterObject.limit = 1000;
                
                let self = this;
                this.getDialogItems("AddOnsDialog", filterObject, 
                    {
                    onSuccess: function (response) {
                        console.log(response);
                        // alert(response);
                        self.charges = JSON.parse(response);
                    },
                    onError: function (error) {
                        console.log(error);
                    }
                    }
                    )
                },

            fn_getAddonsData: function(itemId){
              var self = this;
              this.getData('AddOns', itemId, 
                {
                  onSuccess: function(response){
                    console.log(response);
                    let addOnsData = JSON.parse(response);
                    self.fn_saveAddOns(addOnsData);

                    // self.$parent.fn_openDialogAddons ? self.$parent.fn_openDialogAddons() : '';
                  }, 
                  onError: function(error){
                    console.log(error);
                  }
                }
              );
            },

            fn_saveAddOns: function (data) {

                console.log(JSON.stringify(data));

                // this.Form.newSelection = false;
                localStorage.removeItem('newSelection');

                if(data.mode==0 && (data.percentage==null || data.percentage=='')){
                    data.value = null;
                }

                if(!data.isDefault)
                    data.isDefault = false;

                !data.transactionAddOnsId ? data.transactionAddOnsId = this.guid() : '';

                let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
                    return item.transactionAddOnsId == data.transactionAddOnsId || item.addOnsId == data.addOnsId;
                });

                if(itemIndex==-1){
                    this.Form.transactionAddOns.push(data);
                }
                else{
                    this.Form.transactionAddOns.splice(itemIndex, 1, data);
                }

                // this.fn_closeDialog();
            },

            fn_removeAddOns: function(addOnIndex){
                this.Form.transactionAddOns.splice(addOnIndex, 1);
            },

            fn_getNumberSeries: function(){
                var self = this;
                this.getData('NumberSeries', 'e04a5ba6-48a0-4f54-88ab-02fc102f9671', 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            // let data = JSON.parse(response);
                            self.Form.numberSeriesData = JSON.parse(response);
                            self.fn_bindTransactionNumber();
                            // self.Form = JSON.parse(response);
                        }, 
                        onError: function(error){
                          console.log(error);
                        }
                    }
                );
            },

            fn_bindTransactionNumber: function () {

                let date = new Date();
                let currentMonth = date.getMonth() + 1;
                let currentYear = date.getFullYear();

                let currentFY = currentMonth <= 3 ? (currentYear - 1) : currentYear;

                let currentTransactionNumberData = this.Form.numberSeriesData.transactionNumbers.filter(item=>{
                    return item.fiscalYear == currentFY;
                })

                this.transactionNumberSnackbar = false;

                // let numberSeriesData = this.Form.transactionTypeData.numberSeries;

                this.Form.transactionData.prefix = currentTransactionNumberData[0].prefix;
                this.Form.transactionData.suffix = currentTransactionNumberData[0].suffix;

                //For reference use only as incrementing transaction number by numberSeries id in transaction number
                this.Form.transactionData.numberSeriesId = currentTransactionNumberData[0].numberSeriesId;

                // this.Form.transactionData.transactionNumberId = numberSeriesData.transactionNumberId;

                let filterObject = {};
                filterObject.numberSeriesId = currentTransactionNumberData[0].numberSeriesId;
                // filterObject.transactionNumberId = numberSeriesData.transactionNumberId;
                filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));

                let self = this;

                this.getFilterData('TransactionNumber', null, filterObject, null,
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let data = JSON.parse(response);
                            self.Form.transactionData.transactionNumber = Number(data.transactionNumber);
                            self.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
                            self.Form.transactionData.transactionNumberId = data.transactionNumberId;
                        }, 
                        onError: function(error){
                              console.log(error);
                        }
                    }
                );
                
            },

            fn_openDialogNumberSeries: function(){
                this.transactionNumberSnackbar = false;
                this.$refs['ref_dialogNumberSeries'].openDialogWeb();
            },

            fn_checkTransactionNumber: function(callback){
                var self = this;
                let filterObject = {};
                filterObject.mergeTransactionNumber = this.Form.transactionData.mergeTransactionNumber;
                filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
                filterObject.typeId = 40005;
                let transactionId = this.Form.transactionData.transactionId ? this.Form.transactionData.transactionId : null;
                this.getFilterData('CheckTransactionNumber', transactionId, filterObject, null,
                    {
                        onSuccess: function(response){
                            console.log(response);
                            callback ? callback() : '';
                        }, 
                        onError: function(error){
                            self.disableOnSave = false;
                            self.saveBtnKey++;
                            console.log(error);
                            //   self.showToast('Transaction number already exists');
                            //   self.$eventHub.$emit('snackbarAlert', {msg:'Transaction number already exists'});
                            //   self.hideLoading();
                              self.transactionNumberSnackbar = true;
                        }
                    }
                );
            },

            fn_editItem: function(item, index){
                // this.Form.productData = item;
                this.fn_addProduct('edit', index);
                this.Form.qty = item.qty;
                this.Form.averageRate = item.averageRate;
                this.Form.selectedProduct = {itemId:item.productId, itemName:item.productName};
                this.fn_getProductData(item.productId, item.batches, true);
            },

            fn_menuItemClick: function(menuAction){
                if(menuAction == 'newproduct'){
                    this.$router.push({path:'/'+this.$route.params.businessId + '/' + this.$route.params.listId +'/product/items/new', query:{tagId:this.guidWeb(), ls:1}});
                }
                else if(menuAction=='fromgodown'){
                    this.$router.push({path:'/'+this.$route.params.businessId + '/' + this.$route.params.listId +'/godown/items/new', query:{tagId:this.guidWeb(), ls:1, type:'fromgodown'}});
                }
                else if(menuAction=='togodown'){
                    this.$router.push({path:'/'+this.$route.params.businessId + '/' + this.$route.params.listId +'/godown/items/new', query:{tagId:this.guidWeb(), ls:1, type:'togodown'}});
                }
                else if(menuAction=='addothercharges'){
                    this.$router.push({path:'/addons/othercharges/new', query:{tagId:this.guidWeb(), ls:1}});
                }
            },

            fn_setNewItem: function(){
                let itemData = null;
                if(localStorage.getItem('newItem')){

                    itemData = JSON.parse(localStorage.getItem('newItem'));

                    switch (itemData.type) {
                        case "product":
                            this.fn_addProduct();
                            this.fn_getProductData(itemData.id);
                            this.Form.selectedProduct = {itemId:itemData.id, itemName:itemData.name};
                            break;
                        case "fromgodown":
                            this.fn_getGodowns();
                            this.Form.selectedFromGodown = {itemId:itemData.id, itemName:itemData.name};
                            break;
                        case "togodown":
                            this.fn_getGodowns();
                            this.Form.selectedToGodown = {itemId:itemData.id, itemName:itemData.name};
                            break;
                        case "otherCharges":
                            this.fn_getAddonsData(itemData.id);
                            break;
                            
                        default:
                            console.log("condition not matched");
                    }

                    localStorage.removeItem('newItem');
                }
            },

            fn_goBack: function(){
                this.backButtonPress = true;
                this.$router.go(-1);
            }
        },
        computed:{
            totalAmount: function(){
                let total = 0;
                for(let i=0; i<this.Form.transactionProducts.length; i++){
                    if(this.Form.transactionProducts[i].averageRate){
                        total += this.Form.transactionProducts[i].averageRate * this.Form.transactionProducts[i].qty;
                    }
                }
                return total;
            }
        },
        mounted: function(){

            setTimeout(() => {
                if(this.$root.dialogLoader && !this.loading){
                    this.cacheRetry = true;
                }
            }, 1 * 30 * 1000);

            // !this.$root.CurrentBusiness.DataDrive ? this.fn_checkTransactionCount() : '';

            this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat();

            this.fn_addOns();
            // if(this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
            //     for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
            //         let field = this.$root.TransactionSettings.batchFields[i]
            //         if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
            //             this.hasSeries = true;
            //         }

            //         if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'){
            //             this.hasOnlySeries = false;
            //         }
            //     }
            // }

            // if(!this.Form.selectedBatchType){
            //     this.Form.selectedBatchType = !this.hasOnlySeries ? 1 : 2;
            // }

            if(this.$route.query && this.$route.query.tagId){//in case of new form
                this.formId = this.$route.query.tagId;
                this.draftStorageId = 'draft_transaction_'+this.formId;
            }
            else if(this.$route.params && this.$route.params.tagId){//in case of edit form
                this.formId = this.$route.params.tagId;
                this.draftStorageId = 'draft_transaction_'+this.formId;
            }

            if(localStorage.getItem(this.draftStorageId)){
                let dataObj = JSON.parse(localStorage.getItem(this.draftStorageId));
                this.fn_getGodowns();
                this.Form = JSON.parse(dataObj.formData);
            }

            setTimeout(()=>{this.fn_setNewItem()},300);

            this.seriesFields = [];
            if(this.$root.TransactionSettings.enableBatch && this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
                for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
                    let field = this.$root.TransactionSettings.batchFields[i]
                    if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
                        this.hasSeries = true;
                        this.seriesFields.push(field);
                    }

                    if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'){
                        this.hasOnlySeries = false;
                    }
                }

                if(!this.Form.selectedBatchType){
                    this.Form.selectedBatchType = !this.hasOnlySeries ? 1 : 2;
                }
            }

            this.$refs['ref_dialogForm'].openDialogWeb();

        },
        beforeRouteEnter (to, from, next) {
            next(vm => {

                let itemId = null;

                //edit from display view 
                if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
                    itemId = from.params.tagId;
                    vm.fn_getData(itemId);
                }
                else{
                    vm.fn_getNumberSeries();
                }

            })
        },
        beforeRouteLeave (to, from, next) {
            this.$eventHub.$off('connected');
            next();
        }
        // computed:{
        //     totalAmount: function(){
        //         let rate = this.Form.rate ? this.Form.rate : 0;
        //         return this.roundUpto2Decimals(rate * this.Form.qty);
        //     }
        // }
    }

</script>